import { Box, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { FaDownload } from "react-icons/fa";
import { RiDeleteBin6Line as RiDeleteIcon } from "react-icons/ri";
import { nanoid } from 'nanoid'

import {
  BrowsButtonUI,
  DocumentRoot,
  fileName,
  FileText,
  ReferralDocList,
  ReferralDocMain,
  ReferralDocumentList,
} from "./styles/style";
import {
  flexAlignCentre,
  flexAllCentre,
  justifyContentSpaceBetween,
} from "../../styles/mui/styles/display";
import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { length } from "../../utils";

interface ReferralDocumentProps {
  files: any;
  setFiles: (files: any[]) => void;
  fileRejectionItems: React.ReactNode;
  getRootReferralFileProps: (options?: any) => any;
  getReferralFileProps: () => any;
  open: () => void;
  inputType: string;
  style: React.CSSProperties;
}

export const ReferralDocument = ({
  files,
  setFiles,
  fileRejectionItems,
  getRootReferralFileProps,
  getReferralFileProps,
  open,
  inputType,
  style,
}: ReferralDocumentProps) => {
  return (
    <Box sx={DocumentRoot}>
      <Box>
        <Grid container sx={[flexAllCentre, ReferralDocMain]}>
          <Grid size={5} {...getRootReferralFileProps({ style })}>
            <Box>
              <input className="input-zone" {...getReferralFileProps()} />
              <Box>
                <Box sx={flexAllCentre}>
                  <FaDownload
                    color={colors.fonts[18]}
                    size="1rem"
                    data-testid="drop-file"
                  />
                </Box>
                <Box sx={FileText}>
                  <Typography
                    variant="body1"
                    color={colors.fonts[4]}
                    fontWeight={fontWeight.Weight[5]}
                  >
                    DROP FILE HERE
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={2} sx={flexAllCentre}>
            <Typography
              variant="body1"
              color={colors.fonts[4]}
              fontWeight={fontWeight.Weight[4]}
            >
              OR
            </Typography>
          </Grid>
          <Grid size={5}>
            <Grid container sx={flexAllCentre}>
              <Grid p="1rem" size={12} sx={flexAllCentre}>
                <Button
                  variant="outlined"
                  onClick={open}
                  sx={BrowsButtonUI}
                  data-testid={`${inputType}`}
                >
                  Browse
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box sx={files.length > 3 ? ReferralDocList : ReferralDocumentList}>
          {files &&
            length(files) &&
            files.map((item: any , index:any) => {
              return (
                <Box
                  key={nanoid()}
                  pt=".5rem"
                  sx={[flexAlignCentre, justifyContentSpaceBetween]}
                >
                  <Box sx={fileName}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={fontWeight.Weight[5]}
                      color={colors.fonts[4]}
                      mr="1rem"
                    >
                      {item.name}
                    </Typography>
                  </Box>
                  <Box>
                    <RiDeleteIcon
                      onClick={() =>
                        setFiles(
                          files.filter((file: any) => file.name !== item.name)
                        )
                      }
                      data-testid={`delete-attached-doc-${index}`}
                    />
                  </Box>
                </Box>
              );
            })}
        </Box>
        {fileRejectionItems}
      </Box>
    </Box>
  );
};
